import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import { memo } from 'react';
import NgpTwoButtonDialog from '../dialog-two-button/NgpTwoButtonDialog';
import { ConfirmDiv } from './ConfirmDiv';

const ConfirmDialog = ({ idCount, open, setOpen, onConfirm, label }) => (
    <NgpTwoButtonDialog
        title={<Trans>Confirm {label}</Trans>}
        confirmButtonText={<Trans>{label}</Trans>}
        cancelButtonText={<Trans>Cancel</Trans>}
        open={open}
        setOpen={setOpen}
        onConfirm={onConfirm}
        isWarning
        closeInTitleBar={false}
    >
        <ConfirmDiv idCount={idCount} label={label} />
    </NgpTwoButtonDialog>
);

ConfirmDialog.propTypes = {
    idCount: PropTypes.number,
    open: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    setOpen: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

ConfirmDialog.defaultProps = {
    idCount: 0,
};

ConfirmDialog.displayName = 'ConfirmDialog';

export default memo(ConfirmDialog);
